import { useEffect, useState, useRef } from 'react';
import { useForm } from "react-hook-form";

import { ReactComponent as Cancel } from '../assets/cancel.svg';

import Icon from './Icon';

export default function Rewards({ value, saveRewards, hideRewards }) {

    const [rewards, setRewards] = useState([[]]);
    useEffect(() => {

        console.log('setRewards');

        if (value && value.length > 0) {
            setRewards(value);
            reset();
        }

    }, []);

    console.log('rewards');
    console.log(rewards);


    const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const saveButton = (data) => {

        //console.log(data);
        //console.log(rewards);

        for (let key in data['rewards']) {
            if (rewards[key]['temp_image'])
                data['rewards'][key]['temp_image'] = rewards[key]['temp_image'];
            if (rewards[key]['image'])
                data['rewards'][key]['image'] = rewards[key]['image'];
            else
                data['rewards'][key]['image'] = defaultImage;

        }

        console.log(data['rewards']);

        saveRewards(data['rewards']);
        hideRewards();
    }

    const [message, changeMessage] = useState('');
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };

    const defaultImage = 'https://firebasestorage.googleapis.com/v0/b/lagoon-saas.appspot.com/o/rewards%2Fgift.png?alt=media&token=93a58bd9-3dac-4efa-939c-970bbba04988';

    /*
        useEffect(() => {
    
            var images = [];
            for (let key in rewards){
    
                images.push(rewards[key]['icon'] ? rewards[key]['icon'] : defaultImage);
            }
            setImageUrl (images);
    
        }, [rewards]);
    
        const [image, setImage] = useState([]);
        const [imageUrl, setImageUrl] = useState([]);
    */

    const saveRewardIcon = (file, index) => {

        const objectUrl = URL.createObjectURL(file);

        rewards[index]['temp_image'] = file;
        rewards[index]['image'] = objectUrl;

        setRewards([...rewards]);
        /*
                console.log(file)
                console.log(index);
        
                let temp = Object.assign([], image);
                temp[index] = file;
                setImage(temp);
        
                const objectUrl = URL.createObjectURL(file);
        
        // 		if (!rewards)
        // 			rewards = [];
        // 		rewards[index]['temp_image'] = objectUrl;
        
                temp = Object.assign([], imageUrl);
                temp[index] = objectUrl;
                setImageUrl(temp);
        */
    }

    const hideRewardIcon = (event) => {
    }

    const removeReward = (index) => {
        const updatedRewards = rewards.filter((_, idx) => idx !== index);
        setRewards(updatedRewards);
        reset();
    };

    const addNewReward = () => {
        setRewards([...rewards, []]);
    };

    return (

        <div className="right right_logo texts">
            <div className="dashed-border">
                <div className="title">
                    <div>
                        <div className="name">Reward</div>
                    </div>
                    <div>
                        <div className="cancel" onClick={hideRewards}>
                            <Cancel />
                        </div>
                    </div>
                </div>

                <form className="project_reward reward">

                    {rewards.map((reward, index) => (
                        <div key={"reward" + index} className="reward-item">
                            <button type="button" onClick={() => removeReward(index)} className="button remove-btn">
                                Remove
                            </button>

                            <div className="subtitle">Name</div>
                            <input
                                type="text"
                                {...register("rewards[" + index + "][name]")}
                                placeholder="Reward name"
                                defaultValue={rewards[index] ? rewards[index]['name'] : ''}
                            />
                            <div className="error">{errors.rewards && errors.rewards[index]?.name?.message}</div>

                            <div className="subtitle">Price</div>
                            <input
                                type="number"
                                min={0}
                                max={1000}
                                {...register("rewards[" + index + "][price]")}
                                placeholder="Reward price"
                                defaultValue={rewards[index] ? rewards[index]['price'] : 5}
                            />
                            <div className="error">{errors.rewards && errors.rewards[index]?.price?.message}</div>

                            <div className="subtitle">Instruction</div>
                            <input
                                type="text"
                                {...register(`rewards[${index}].instruction`)}
                                placeholder="Instruction (optional)"
                                defaultValue={reward['instruction'] || ''}
                            />
                            <div className="error">{errors.rewards && errors.rewards[index]?.instruction?.message}</div>

                            <Icon index={index} icon={rewards[index]['image'] ? rewards[index]['image'] : defaultImage} saveIcon={saveRewardIcon} hideIcon={hideRewardIcon} size="512" />

                        </div>
                    ))}

                    <div className="buttons">
                        <button type="button" onClick={addNewReward} className="button add">
                            Add New Reward
                        </button>

                        <button type="submit" className="button check save" onClick={handleSubmit(saveButton)}>
                            Save
                        </button>
                        <div className="error">{message}</div>
                    </div>

                </form>

            </div>

        </div>

    )

}
